import { render, staticRenderFns } from "./ActionsNavigateCitationStudies.vue?vue&type=template&id=2679e565&scoped=true"
import script from "./ActionsNavigateCitationStudies.vue?vue&type=script&lang=js"
export * from "./ActionsNavigateCitationStudies.vue?vue&type=script&lang=js"
import style0 from "./ActionsNavigateCitationStudies.vue?vue&type=style&index=0&id=2679e565&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2679e565",
  null
  
)

export default component.exports